import * as React from "react";
import type { SVGProps } from "react";
const SvgPieChart03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M21.6 12A9.6 9.6 0 0 0 12 2.4m9.6 9.6q0 0 0 0m0 0A9.6 9.6 0 1 1 12 2.4m9.6 9.6H12m0-9.6V12m0 0-6.6 6.6"
    />
  </svg>
);
export default SvgPieChart03;
